<template>
    <div class="wrapper">
        <div class="row">
            <messages :data="messages" class="statistics messages col-sm"></messages>
        </div>
        <div class="row">
            <api-calls :data="apiCalls" class="statistics api-calls col-sm-6"></api-calls>
            <devices :data="devices" class="statistics devices col-sm"></devices>
        </div>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import messages from '@/components/statistics/messages';
import devices from '@/components/statistics/devices';
import apiCalls from '@/components/statistics/apiCalls';

export default {
    name: 'statistics',
    components: {
        messages,
        devices,
        apiCalls
    },
    mixins: [
        Default
    ],
    data() {
        return {
            messages: [],
            devices: [],
            apiCalls: []
        };
    },
    mounted() {
        this.getMessages();
        this.getDevices();
        this.getApiCalls();
    },
    methods: {
        getMessages: function() {
            // Get message counts from API
            this.$http.get('v1.1/statistics/messages', {
                params: {
                    end: Math.floor(Date.now() / 1000)
                }
            }).then(response => {
                // Success callback
                this.messages = response.body.data;
            }, response => {
                // Error callback
                this.messages = [];
            });
        },
        getDevices: function() {
            // Get device counts from API
            this.$http.get('v1.1/statistics/devices', {
                params: {
                    end: Math.floor(Date.now() / 1000)
                }
            }).then(response => {
                // Success callback
                this.devices = response.body.data;
            }, response => {
                // Error callback
                this.devices = [];
            });
        },
        getApiCalls: function() {
            // Get api call log from API
            this.$http.get('v1.1/statistics/apicalls').then(response => {
                // Success callback
                this.apiCalls = response.body.data;
            }, response => {
                // Error callback
                this.apiCalls = [];
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .wrapper {
        padding: 2em;
        max-height: inherit;
        overflow: auto;
    }

    .statistics {
        background-color: white;
        -webkit-box-shadow: 4px 4px 23px -4px rgba(0,0,0,0.21);
        -moz-box-shadow: 4px 4px 23px -4px rgba(0,0,0,0.21);
        box-shadow: 4px 4px 23px -4px rgba(0,0,0,0.21);
        -webkit-border-radius: .25em;
        -moz-border-radius: .25em;
        border-radius: .25em;
        margin: 0 0 2em 0;

        &.messages {
            width: 100%;
            height: 27.5em;
        }

        &.devices {
            height: fit-content;
            min-height: 20em;
            margin: 1em 0 0 0;
        }

        &.api-calls {
            width: 60em;
            height: 20em;
            margin: 1em 1em 0 0;
        }
    }
</style>
